import { Config } from '../../config'

export const nycomConfig: Config = {
  partner: 'nycom',
  catalog: 'partner',
  displayName: 'Nycom Inc',
  accentColor: '#381d28',
  host: 'seating.nycominc.com',
}

